import { useLicensingServiceV1 } from "@rw1/api-services";
import { Licensing_V1 } from "@rw1/auto-generated-clients";
import {
  useMutation,
  UseMutationResult,
  useQueryClient,
} from "@tanstack/react-query";
import { ALL_LICENSES_QUERY_KEY } from "./useExternalLicenses";
import { LICENSE_BY_ID_QUERY_KEY } from "./useLicenseById";

export interface UseUpdateLicenseProps {
  licenseId: string;
  licenseData: Licensing_V1.LicenseBase;
  onSuccess?: () => void;
}

export const useUpdateLicense = (): UseMutationResult<
  Licensing_V1.License,
  Error,
  UseUpdateLicenseProps
> => {
  const licensingService = useLicensingServiceV1();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ licenseId, licenseData }: UseUpdateLicenseProps) => {
      return await licensingService.updateLicenseById(licenseId, licenseData);
    },
    onSuccess: (response, variables) => {
      queryClient.setQueryData(
        [LICENSE_BY_ID_QUERY_KEY, variables.licenseId],
        ({ allocatedSeats }: Licensing_V1.License) => {
          return { ...response, allocatedSeats };
        },
      );
      void queryClient.invalidateQueries({
        queryKey: [LICENSE_BY_ID_QUERY_KEY, variables.licenseId],
      });
      void queryClient.invalidateQueries({
        queryKey: [ALL_LICENSES_QUERY_KEY],
      });
      variables.onSuccess?.();
    },
  });
};
